<template>
  <div class="mod-joylearning__offringlist}">
    <div class="pkg-search-box">
      <el-form
        class="pkg-content"
        label-width="auto"
        label-position="top"
        :model="dataForm"
        ref="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-row class="margb10">
          <el-col :span="5" class="padt5">
            <!-- 结算时经销商中文名称 -->
            <el-form-item label="结算时经销商中文名称">
              <el-input
                v-model="dataForm.orgParentNameCn"
                :placeholder="$t('名称/NSC/BBA')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 结算ID -->
            <el-form-item label="结算ID">
              <el-input
                v-model="dataForm.settlementId"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 培训记录编号 -->
            <el-form-item label="培训记录编号">
              <el-input
                v-model="dataForm.trainingKey"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 排期编号 -->
            <el-form-item label="排期编号">
              <el-input
                v-model="dataForm.offeringNo"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 查询 -->
            <el-button
              class="M-search"
              style="margin-bottom: 7px"
              type="primary"
              @click="getDataListMerge"
              >{{ $t("query") }}</el-button
            >
            <!-- 重置 -->
            <el-button
              class="el-back M-search M-margin-l"
              type="info"
              @click="again"
              >{{ $t("reset") }}</el-button
            >
          </el-col>
        </el-row>
        <el-row class="margb10" v-show="isShow">
          <el-col :span="10" class="padt5">
            <el-form-item style="width: 90% !important;" label="排期开始时间">
                <el-date-picker
                    @change="createTimeChange"
                    v-model="dataForm.startTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    style="width: 100%"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" class="padt5">
            <el-form-item style="width: 90% !important;" label="排期结束时间">
                <el-date-picker
                    @change="updateTimeChange"
                    v-model="dataForm.endTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    style="width: 100%"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margb10" v-show="isShow">

          <el-col :span="5" class="padt5">
            <!-- 结算状态 -->
            <el-form-item label="结算状态">
              <el-select
                v-model="dataForm.balanceAcountStatus"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="padt5">
            <!-- 创建人 -->
            <el-form-item label="创建人">
              <el-input
                v-model="dataForm.createUser"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" class="padt5">
            <el-form-item style="width: 90% !important;" label="创建时间">
                <el-date-picker
                    @change="updateTimeChange"
                    v-model="dataForm.createTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    style="width: 100%"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 展开显示更多 -->
        <ToggleDiv @toggle="toggle"></ToggleDiv>
      </el-form>
    </div>

    <div class="pkg-content">
      <div class="search">
        <!-- 删除 -->
        <el-button  type="primary" @click="deleteDatas"
          >{{ $t("offering.listDelete") }}
        </el-button>
        <!-- 数据下载 -->
        <el-button type="primary" @click="download"
          >待结算数据下载
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div  slot="content">
               可以下载待区分CBU账号结算的待结算数据，其中，不包含不需要发送给SAP的结算数据，如：因减免，返还等产生的0元结算数据，或者，状态为缺勤，撤销等不需要结算的数据。
              </div>
              <em style="color: #fff" class="el-icon-question"></em>
            </el-tooltip>
        </el-button>
        <!-- 导入 -->
        <el-button type="primary" @click="handleImport"
          >导入待结算数据
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div  slot="content">
                  1.需要使用CBU账户结算的经销商，可区分好【结算时经销商编号】后，导入到系统中，次日可在本页面查看结算状态。
                <br/>
                <br/>
                  2.如导入过程中发现有结算ID不存在的情况，表示此结算数据已经发生了变更，可删除此结算数据重新导入，发生变更的新结算数据可以在下次导入时一并处理。
                <br/>
                <br/>
                  3.结算数据导入后，到次日结算完成之前，此结算数据相关的培训记录，不能做状态修改和手工平账。
              </div>
              <em style="color: #fff" class="el-icon-question"></em>
            </el-tooltip>
        </el-button>
        <!-- 导出 -->
        <el-button type="primary" @click="exportData"
          >导出
        </el-button>
      </div>
      <!-- 表头动态展示 -->
      <el-table
        v-loading="dataListLoading"
        ref="multipleTable"
        :data="dataList"
        border
        :row-style="{ height: 48 + 'px' }"
        :cell-style="{ padding: 0 + 'px' }"
        @selection-change="handleSelectionChange">
        <el-table-column
          header-align="center"
          align="center"
          type="selection"
          width="55"
          :selectable="selectable">
        </el-table-column>
        <!-- 结算状态 -->
        <el-table-column
          prop="dealStatus"
          label="结算状态"
          header-align="center"
          align="center"
          min-width="100"
          :show-overflow-tooltip="true"
          :formatter="statusFormat"
        ></el-table-column>
        <!--结算ID-->
        <el-table-column
          prop="balanceCode"
          label="结算ID"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          min-width="150"
        ></el-table-column>
        <!-- 结算时经销商编号 -->
        <el-table-column
          header-align="center"
          align="center"
          min-width="210"
          prop="dealerNumber"
        >
          <template slot="header">
            <div style="line-height: 1.15;display: block;">
              结算时经销商编号
              <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
              >
                <div slot="content">实际结算的经销商编号（CKD或者CBU）</div>
                <img
                        style="width: 14px; height: 14px"
                        src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                        alt=""
                />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <!-- 结算时经销商中文名称 -->
        <el-table-column
          prop="registeParentName"
          label="结算时经销商中文名称"
          header-align="center"
          align="center"
          min-width="200"
        ></el-table-column>
        <!--结算时经销商品牌-->
        <el-table-column
          label="结算时经销商品牌"
          prop="registeParentBrand"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          min-width="150"
        ></el-table-column>
        <!-- 结算时网点类型 -->
        <el-table-column
          prop="registeParentOutletType"
          label="结算时网点类型"
          header-align="center"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
          v-if="false"
        ></el-table-column>
        <!-- 报名时所属经销商编号(BBA) -->
        <el-table-column
          prop="registeBbaNo"
          label="报名时所属经销商编号(BBA)"
          header-align="center"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 用户ID -->
        <el-table-column
          prop="userCode"
          label="用户ID"
          header-align="center"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
         <!-- 员工号 -->
        <el-table-column
          prop="userCardNo"
          label="员工号"
          header-align="center"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
          v-if="false"
        ></el-table-column>
        <!-- 用户姓名 -->
        <el-table-column
          prop="userName"
          label="姓名"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 培训记录编号 -->
        <el-table-column
          prop="trainingKey"
          label="培训记录编号"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 课程中文名称 -->
        <el-table-column
          prop="courseName"
          label="课程中文名称"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 课程代码 -->
        <el-table-column
          prop="courseCode"
          label="课程代码"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 排期编号 -->
        <el-table-column
          prop="offeringNo"
          label="排期编号"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 开始时间 -->
        <el-table-column
          prop="trainingStartDate"
          label="开始时间"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 结束时间 -->
        <el-table-column
          prop="trainingEndDate"
          label="结束时间"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 场地 -->
        <el-table-column
          prop="offeringSiteCn"
          label="场地"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
          v-if="false"
        ></el-table-column>
         <!-- 培训记录状态 -->
        <el-table-column
          prop="trainingStatus"
          label="培训记录状态"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
          :formatter="format"
        ></el-table-column>
        <!-- 应付款费用 -->
        <el-table-column
          prop="balanceAmount"
          label="费用"
          header-align="center"
          align="right"
          min-width="150"
          :show-overflow-tooltip="true"
        >
         <template slot-scope="scope">
             {{ scope.row.balanceAmount | formatMoney }}
         </template>
        </el-table-column>
        <!-- 数据传输时间 -->
        <el-table-column
          prop="synchroTime"
          label="数据传输时间"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
          v-if="false"
        ></el-table-column>
        <!-- 摘要（分类） -->
        <el-table-column
          prop="summaryType"
          label="摘要（分类）"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
          v-if="false"
        ></el-table-column>
        <!-- 发票号 -->
        <el-table-column
          prop="billNo"
          label="发票号"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 备注 -->
        <el-table-column
          prop="remark"
          label="备注"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
          v-if="false"
        ></el-table-column>
        <!-- 创建人 -->
        <el-table-column
          prop="createUserCn"
          label="创建人"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 创建时间 -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 更新人 -->
        <el-table-column
          prop="updateUserCn"
          label="更新人"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 更新时间 -->
        <el-table-column
          prop="updateTime"
          label="更新时间"
          header-align="center"
          align="center"
          min-width="150"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('offering.operation')"
          fixed="right"
          header-align="center"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <el-button v-if="checkDealStatus(scope.row)" @click.native="deleteData(scope.row)" type="text" size="medium">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
    <import-excel
      v-bind:visible="isShowImportDialog"
      v-bind:url="importExcelUrl"
      v-on:closeDialogImport="isShowImportDialog = false"
      @importData="importData"
    ></import-excel>
  </div>
</template>

<script>
import importExcel from "./importSettlement";
import ToggleDiv from '@/components/toggle-div';
import mixinViewModule from "@/mixins/view-module";

export default {

  mixins: [mixinViewModule],
  name: "settlementDataManagement",
  data() {
    return {
      isShowImportDialog: false,
      mixinViewModuleOptions: {
        downloadUrl: "/finance/settlementManagement/download",
        exportUrl: "/finance/settlementManagement/export",
        getDataListURL: "/finance/settlementManagement/querySettlements",
        deleteDataUrl:"/finance/settlementManagement/deleteSettlement",
        deleteDatasUrl:"/finance/settlementManagement/deleteSettlements",
        getDataListIsPage: true,
      },
      isShow: false,
      dataList: [
      ],
      dataForm: {
        orgParentNameCn: "",
        settlementId: "",
        trainingKey: "",
        offeringNo: "",
        startTime: [],
        endTime: [],
        balanceAcountStatus: "",
        createUser: "",
        createTime: []
      },
      deleteForm: {
        id: "",
        sourceId: "",
        balanceAccountNo: "",
        balanceAccountTitle: "",
        amountType: "",
        balanceAccountType: "",
        singleAmount: "",
        balanceDes: "",
        fileList: [],
        trainingRecordList: [],
      },
      emptyForm: {
        orgParentNameCn: "",
        settlementId: "",
        trainingKey: "",
        offeringNo: "",
        startTime: [],
        endTime: [],
        balanceAcountStatus: "",
        createUser: "",
        createTime: []
      },
      statusList: [
        { label: "待发送", value: "0" },
        { label: "已发送", value: "1" },
        { label: "已结算", value: "3" },
      ],
      multipleSelection: [],
      importExcelUrl: "/finance/settlementManagement/import",
    };
  },
  components:{
    importExcel,
    ToggleDiv
  },
  created() {
    this.dataForm = JSON.parse(JSON.stringify(this.emptyForm))
  },
  filters: {
  rounding (value) {
    return value.toFixed(2)
    },
     formatMoney(num) {
      if (!num && num !== 0 && num !== '0') {
        return ''
      }
      num = num.toString().replace(/\$|\,/g, '')
      if (isNaN(num)) {
        num = '0'
      }
      let sign = num == (num = Math.abs(num))
      num = Math.floor(num * 100 + 0.50000000001)
      let cents = num % 100
      num = Math.floor(num / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      return (sign ? '' : '-') + num + '.' + cents
    }
  },
  methods: {
    formatMoney(num) {
      if (!num && num !== 0 && num !== '0') {
        return ''
      }
      num = num.toString().replace(/\$|\,/g, '')
      if (isNaN(num)) {
        num = '0'
      }
      let sign = num == (num = Math.abs(num))
      num = Math.floor(num * 100 + 0.50000000001)
      let cents = num % 100
      num = Math.floor(num / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      return (sign ? '' : '-') + num + '.' + cents
    },
    //校验结算状态
    checkDealStatus(row){
      if(row.dealStatus === '0' || row.dealStatus === '5' || row.dealStatus === '6') {
        return true
      } else {
        return false
      }
    },
    // 查询
    getDataListMerge() {
      this.page = 1;
      this.getDataList();
    },
    handleImport() {
      this.isShowImportDialog = true
    },
    importData(data) {
      if (data.code === 1) {
        this.$message({
          message: "导入成功",
          type: "SUCCESS",
          duration: 1500,
        });
      }
      this.getDataList()
    },
    exportData(){
      this.$request.downloadITM(this.mixinViewModuleOptions.exportUrl,'CBU结算开票数据导出',this.dataForm)
    },
    selectable(row,index){
      if(row.dealStatus === '0' || row.dealStatus === '5' || row.dealStatus === '6'){
        return true
      } else {
        return false
      }
    },
    getDataList() {
      this.dataListLoading = true
      this.$request.get(
                  this.mixinViewModuleOptions.getDataListURL,
                  {
                    page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
                    limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
                    ...this.dataForm
                  }
                ).then((res, total, code, data) => {
                  console.log(data)
                  this.dataList = data.data.records
                  this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
                  this.dataListLoading = false
                }).catch(() => {
                  this.dataListLoading = false
                })
    },
    download() {
      this.$request.downloadITM(this.mixinViewModuleOptions.downloadUrl, 'CBU结算数据下载')
    },
    // 重置
    again() {
      this.dataForm = JSON.parse(JSON.stringify(this.emptyForm))
      this.page = 1;
      this.createTime = [];
      this.updateTime = [];
      this.getDataList();
    },
    //多选框
    handleSelectionChange(val) {
      this.multipleSelection = val;
      },
    toggle(val) {
      this.isShow = val
    },
    createTimeChange() {
            if (this.createTime && this.createTime.length > 1) {
                this.dataForm.beginCreateTime = this.createTime[0];
                this.dataForm.endCreateTime = this.createTime[1];
            } else {
                this.dataForm.beginCreateTime = '';
                this.dataForm.beginCreateTime = '';
            }
        },
    updateTimeChange() {
        if (this.updateTime && this.updateTime.length > 1) {
            this.dataForm.beginUpdateTime = this.updateTime[0];
            this.dataForm.endUpdateTime = this.updateTime[1];
        } else {
            this.dataForm.beginUpdateTime = '';
            this.dataForm.endUpdateTime = '';
        }
    },
    // 删除单条
    deleteData(row){
      this.$confirm(
        this.$t('prompt.info', { handle: this.$t('delete') }),
        this.$t('prompt.title'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      )
        .then(() => {
      this.dataListLoading = true
      this.deleteForm = row
      this.$request.post(
                  this.mixinViewModuleOptions.deleteDataUrl,
                    this.deleteForm
                ).then((res, total, code, data) => {
                  this.$message({
                    message: '删除成功',
                    type: 'success',
                    duration: 1500,
                  })
                  this.getDataList();
                }).catch(() => {
                  this.dataListLoading = false
                })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 删除多条
    deleteDatas(row){
      if(this.multipleSelection.length <= 0){

        this.$message({
                    message: '请选择要删除的数据',
                    type: 'warning',
                    duration: 1500,
                  })
      } else {
        this.$confirm(
          this.$t('prompt.info', { handle: this.$t('delete') }),
          this.$t('prompt.title'),
          {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel')
          }
        )
          .then(() => {
        this.dataListLoading = true
        this.deleteForm = row
        this.$request.post(
                    this.mixinViewModuleOptions.deleteDatasUrl,
                    this.multipleSelection
                  ).then((res, total, code, data) => {
                    this.$message({
                      message: '删除成功',
                      type: 'success',
                      duration: 1500,
                    })
                    this.getDataList();
                  }).catch(() => {
                    this.dataListLoading = false
                  })
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    statusFormat(row, column) {
      if(row.dealStatus === "0"){
        return "待发送"
      }else if(row.dealStatus === "1"){
        return "已发送"
      }else if(row.dealStatus === "5"){
        return "待发送"
      }else if(row.dealStatus === "6"){
        return "待发送"
      }else{
        return "已结算"
      }
    },
   format(row,column){
      if(row.trainingStatus === "10"){
        return "已报名"
      } else if(row.trainingStatus === "20"){
        return "已撤销"
      } else if(row.trainingStatus === "30"){
        return "等待中"
      } else if(row.trainingStatus === "40"){
        return "待审批"
      } else if(row.trainingStatus === "50"){
        return "已拒绝"
      } else if(row.trainingStatus === "60"){
        return "已取消"
      } else if(row.trainingStatus === "70"){
        return "未通过"
      } else if(row.trainingStatus === "80"){
        return "已完成"
      } else if(row.trainingStatus === "90"){
        return "缺勤"
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";

.aui-wrapper .el-date-editor .el-range-separator {
  width: 30px;
}

.jieshu .el-form-item__content {
  width: 94.5%;
}

.kaishi .el-form-item__content {
  width: 111%;
}

.el-row {
  margin-bottom: 0px;
}

#container {
  display: -webkit-flex;
}

.el-date-editor.el-input {
  width: 150px;
}

.search-item {
  width: 94% !important;
  min-width: 290px;
}

.search {
  height: 50px;
}

.wrapper-div {
  .el-dialog__title {
    text-align: center;
    display: block;
  }
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

 .search-item .el-form-item__content {
  margin-left: 96px !important;
}

.margb10 {
  min-height: 75px;
}
</style>
